import { useList } from '@refinedev/core';

/**
 * Total row count for a whole-collection resource (sidebar badges +
 * dashboard cards). Piggybacks on dataProvider.getList with a 1-row page —
 * the provider fetches the full collection anyway and returns `total`.
 * Only resources dataProvider.getList supports may be passed.
 */
export const COUNTABLE_RESOURCES = new Set(['users', 'api-keys', 'tracks', 'prompts', 'permissions', 'models']);

export function useResourceCount(resource: string): number | undefined {
  const enabled = COUNTABLE_RESOURCES.has(resource);
  const { result } = useList({
    resource,
    pagination: { currentPage: 1, pageSize: 1 },
    queryOptions: { enabled, staleTime: 30_000 },
  });
  return enabled ? result?.total : undefined;
}
